import React from 'react';
import { MidFormData } from 'common/types/mid-form-data';
import { MidControlCode } from '../../../../../../components';
import { MobileIdSubForm } from '../../../';
import { MidControlCodeData } from '../../../../../../common/types/mid-control-code-data';

export interface MidTabPanelProps {
  authCountryCode: string;
  midControlCodeData: MidControlCodeData;
  setMidControlCodeData: (data: MidControlCodeData) => void;
  socketErrorCode: string;
  setSocketErrorCode: (code: string) => void;
  midContinueBtnRef: React.RefObject<HTMLButtonElement | null>;
  initialMidControlCodeData: MidControlCodeData;
}

export const MidTabPanel = ({
  authCountryCode,
  midControlCodeData,
  setMidControlCodeData,
  socketErrorCode,
  setSocketErrorCode,
  midContinueBtnRef,
  initialMidControlCodeData,
}: MidTabPanelProps) => {
  if (midControlCodeData.authData) {
    return (
      <MidControlCode
        controlCodeData={midControlCodeData}
        closeControlCode={() => setMidControlCodeData({ ...initialMidControlCodeData })}
        setSocketErrorCode={setSocketErrorCode}
      />
    );
  }

  return (
    <MobileIdSubForm
      authCountryCode={authCountryCode}
      onSubmitSuccess={(formData: MidFormData) => {
        setMidControlCodeData({
          authData: { ...formData, authCountryCode },
        });
      }}
      socketErrorCode={socketErrorCode}
      setSocketErrorCode={setSocketErrorCode}
      continueButtonRef={midContinueBtnRef}
    />
  );
};
